import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const departments = [
  {
    id: "klassiker",
    title: "Wiederentdeckte Klassiker",
    description: "Versteckte Klassiker, sorgfältig kuratiert und für die heutige Leserschaft im neuen Gewand aufgelegt.",
    image: "/images/dept-belletristik.jpg",
    color: "bg-brand"
  },
  {
    id: "demografie",
    title: "Demografie",
    description: "Grundlagen für gesellschaftliche Analysen und Diskurse zum demografischen Wandel.",
    image: "/images/dept-sachbuch.jpg",
    color: "bg-amber-900"
  },
  {
    id: "kinder",
    title: "Kinder- und Jugendbücher",
    description: "Fantasievolle Welten, spannende Abenteuer und lehrreiche Geschichten, die junge Leser inspirieren.",
    image: "/images/books-general.jpg",
    color: "bg-teal-900"
  }
];

const Departments = () => {
  return (
    <section id="abteilungen" className="py-24 bg-white dark:bg-navy-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-900 dark:text-stone-100 mb-4">
            Unsere Verlagsabteilungen
          </h2>
          <div className="w-24 h-1 bg-amber-700 dark:bg-amber-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {departments.map((dept, index) => (
            <motion.div
              key={dept.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group cursor-pointer rounded-lg overflow-hidden shadow-md hover:shadow-xl dark:shadow-navy-900 transition-shadow duration-300 bg-stone-50 dark:bg-navy-800 flex flex-col"
            >
              <Link to={`/abteilung/${dept.id}`}>
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={dept.image}
                    alt={dept.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className={`absolute inset-0 opacity-20 group-hover:opacity-10 transition-opacity duration-300 ${dept.color}`}></div>
                </div>
                <div className="p-8 flex-grow">
                  <h3 className="text-xl font-serif font-bold text-stone-900 dark:text-stone-100 mb-3">{dept.title}</h3>
                  <p className="text-stone-600 dark:text-stone-400 leading-relaxed mb-6">
                    {dept.description}
                  </p>
                  <span className="text-amber-800 dark:text-amber-400 font-bold border-b-2 border-transparent group-hover:border-amber-800 dark:group-hover:border-amber-400 transition-all text-sm uppercase tracking-wider">
                    Alle Titel ansehen
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Departments;
